import { render, staticRenderFns } from "./OccupationForm.vue?vue&type=template&id=039ec000&scoped=true"
import script from "./OccupationForm.vue?vue&type=script&lang=js"
export * from "./OccupationForm.vue?vue&type=script&lang=js"
import style0 from "./OccupationForm.vue?vue&type=style&index=0&id=039ec000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ec000",
  null
  
)

export default component.exports